/* eslint-disable */

var atcSetup = {
    lib: {
        apple: {
            label: "Apple",
            ics: !0,
            dateType: 1,
            icon: '<svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25"><path fill="gray" d="M9.112 23.472C5.767 23.452 3 16.625 3 13.148c0-5.68 4.26-6.923 5.903-6.923.74 0 1.53.291 2.227.548.487.18.991.365 1.271.365.168 0 .564-.158.913-.296.744-.296 1.67-.665 2.75-.665h.006c.805 0 3.248.177 4.716 2.382l.344.517-.495.374c-.707.533-1.997 1.507-1.997 3.435 0 2.283 1.461 3.162 2.163 3.584.31.186.63.379.63.8 0 .274-2.19 6.169-5.372 6.169-.779 0-1.329-.234-1.814-.44-.492-.21-.915-.39-1.615-.39-.355 0-.804.168-1.28.346-.648.242-1.383.518-2.217.518h-.022zM16.402 1c.082 2.988-2.054 5.06-4.189 4.93C11.862 3.547 14.347 1 16.402 1z"/></svg>'
        },
        google: {
            label: "Google Calendar",
            dateType: 1,
            href: "https://www.google.com/calendar/render?action=TEMPLATE&text={title}&details={description}&location={location}&dates={Dstart}%2F{Dend}&ctz={timezone}",
            icon: '<svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25"><g fill="none"><path fill="#4285F4" d="M22.79 12.868c0-.72-.058-1.443-.183-2.151h-9.984v4.076h5.717a4.9 4.9 0 0 1-2.116 3.217v2.645h3.412c2.003-1.844 3.154-4.567 3.154-7.787z"/><path fill="#34A853" d="M12.623 23.21c2.855 0 5.262-.937 7.016-2.555l-3.41-2.645c-.95.645-2.175 1.011-3.603 1.011-2.761 0-5.103-1.863-5.943-4.368h-3.52v2.727a10.587 10.587 0 0 0 9.46 5.83z"/><path fill="#FBBC04" d="M6.68 14.653a6.34 6.34 0 0 1 0-4.053V7.873H3.162a10.595 10.595 0 0 0 0 9.507l3.516-2.727z"/><path fill="#EA4335" d="M12.623 6.228a5.752 5.752 0 0 1 4.06 1.587l3.023-3.022a10.174 10.174 0 0 0-7.083-2.754 10.584 10.584 0 0 0-9.46 5.834L6.679 10.6c.836-2.509 3.182-4.372 5.944-4.372z"/></g></svg>'
        },
        yahoo: {
            label: "Yahoo Calendar",
            dateType: 2,
            href: "https://calendar.yahoo.com/?desc={description}&dur=0200&et={Dend}&in_loc={location}&st={Dstart}&title={title}&v=60",
            icon: '<svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25"><path fill="#5F01D1" d="M1 6.928h4.342l2.529 6.468 2.561-6.468h4.228L8.294 22.24H4.039l1.743-4.058L1 6.928zm18.583 5.168h-4.735L19.05 2h4.718l-4.185 10.096zm-3.495.966a2.63 2.63 0 1 1 0 5.261 2.63 2.63 0 0 1 0-5.26z"/></svg>'
        },
        outlook: {
            label: "Outlook",
            dateType: 2,
            href: "https://outlook.office.com/calendar/0/deeplink/compose?body={description}&enddt={Dend}&location={location}&path=/calendar/action/compose&startdt={Dstart}&subject={title}",
            icon: '<svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25"><path fill="#FF5722" d="M21.44 2.893l-6.563-1.875a.469.469 0 0 0-.31.018L3.318 5.724a.469.469 0 0 0-.287.432v12.187a.47.47 0 0 0 .464.469.469.469 0 0 0-.143.914l11.25 3.75a.482.482 0 0 0 .276.005l6.563-1.875a.469.469 0 0 0 .34-.45V3.343a.47.47 0 0 0-.34-.45zM3.709 18.763l2.812-1.407a.469.469 0 0 0 .259-.42V6.992l8.437-2.11V20.61L3.57 18.818a.407.407 0 0 0-.067-.006.475.475 0 0 0 .206-.05z"/></svg>'
        }
    }, offsets: {
        "Africa/Abidjan": "+00:00",
        "Africa/Accra": "+00:00",
        "Africa/Addis_Ababa": "+03:00",
        "Africa/Algiers": "+01:00",
        "Africa/Asmara": "+03:00",
        "Africa/Asmera": "+03:00",
        "Africa/Bamako": "+00:00",
        "Africa/Bangui": "+01:00",
        "Africa/Banjul": "+00:00",
        "Africa/Bissau": "+00:00",
        "Africa/Blantyre": "+02:00",
        "Africa/Brazzaville": "+01:00",
        "Africa/Bujumbura": "+02:00",
        "Africa/Cairo": "+02:00",
        "Africa/Casablanca": "+01:00",
        "Africa/Ceuta": "+01:00",
        "Africa/Conakry": "+00:00",
        "Africa/Dakar": "+00:00",
        "Africa/Dar_es_Salaam": "+03:00",
        "Africa/Djibouti": "+03:00",
        "Africa/Douala": "+01:00",
        "Africa/El_Aaiun": "+01:00",
        "Africa/Freetown": "+00:00",
        "Africa/Gaborone": "+02:00",
        "Africa/Harare": "+02:00",
        "Africa/Johannesburg": "+02:00",
        "Africa/Juba": "+02:00",
        "Africa/Kampala": "+03:00",
        "Africa/Khartoum": "+02:00",
        "Africa/Kigali": "+02:00",
        "Africa/Kinshasa": "+01:00",
        "Africa/Lagos": "+01:00",
        "Africa/Libreville": "+01:00",
        "Africa/Lome": "+00:00",
        "Africa/Luanda": "+01:00",
        "Africa/Lubumbashi": "+02:00",
        "Africa/Lusaka": "+02:00",
        "Africa/Malabo": "+01:00",
        "Africa/Maputo": "+02:00",
        "Africa/Maseru": "+02:00",
        "Africa/Mbabane": "+02:00",
        "Africa/Mogadishu": "+03:00",
        "Africa/Monrovia": "+00:00",
        "Africa/Nairobi": "+03:00",
        "Africa/Ndjamena": "+01:00",
        "Africa/Niamey": "+01:00",
        "Africa/Nouakchott": "+00:00",
        "Africa/Ouagadougou": "+00:00",
        "Africa/Porto-Novo": "+01:00",
        "Africa/Sao_Tome": "+00:00",
        "Africa/Timbuktu": "+00:00",
        "Africa/Tripoli": "+02:00",
        "Africa/Tunis": "+01:00",
        "Africa/Windhoek": "+02:00",
        "America/Adak": "-10:00",
        "America/Anchorage": "-09:00",
        "America/Anguilla": "-04:00",
        "America/Antigua": "-04:00",
        "America/Araguaina": "-03:00",
        "America/Argentina/Buenos_Aires": "-03:00",
        "America/Argentina/Catamarca": "-03:00",
        "America/Argentina/ComodRivadavia": "-03:00",
        "America/Argentina/Cordoba": "-03:00",
        "America/Argentina/Jujuy": "-03:00",
        "America/Argentina/La_Rioja": "-03:00",
        "America/Argentina/Mendoza": "-03:00",
        "America/Argentina/Rio_Gallegos": "-03:00",
        "America/Argentina/Salta": "-03:00",
        "America/Argentina/San_Juan": "-03:00",
        "America/Argentina/San_Luis": "-03:00",
        "America/Argentina/Tucuman": "-03:00",
        "America/Argentina/Ushuaia": "-03:00",
        "America/Aruba": "-04:00",
        "America/Asuncion": "-04:00",
        "America/Atikokan": "-05:00",
        "America/Atka": "-10:00",
        "America/Bahia": "-03:00",
        "America/Bahia_Banderas": "-06:00",
        "America/Barbados": "-04:00",
        "America/Belem": "-03:00",
        "America/Belize": "-06:00",
        "America/Blanc-Sablon": "-04:00",
        "America/Boa_Vista": "-04:00",
        "America/Bogota": "-05:00",
        "America/Boise": "-07:00",
        "America/Buenos_Aires": "-03:00",
        "America/Cambridge_Bay": "-07:00",
        "America/Campo_Grande": "-04:00",
        "America/Cancun": "-05:00",
        "America/Caracas": "-04:00",
        "America/Catamarca": "-03:00",
        "America/Cayenne": "-03:00",
        "America/Cayman": "-05:00",
        "America/Chicago": "-06:00",
        "America/Chihuahua": "-07:00",
        "America/Coral_Harbour": "-05:00",
        "America/Cordoba": "-03:00",
        "America/Costa_Rica": "-06:00",
        "America/Creston": "-07:00",
        "America/Cuiaba": "-04:00",
        "America/Curacao": "-04:00",
        "America/Danmarkshavn": "+00:00",
        "America/Dawson": "-07:00",
        "America/Dawson_Creek": "-07:00",
        "America/Denver": "-07:00",
        "America/Detroit": "-05:00",
        "America/Dominica": "-04:00",
        "America/Edmonton": "-07:00",
        "America/Eirunepe": "-05:00",
        "America/El_Salvador": "-06:00",
        "America/Ensenada": "-08:00",
        "America/Fort_Nelson": "-07:00",
        "America/Fort_Wayne": "-05:00",
        "America/Fortaleza": "-03:00",
        "America/Glace_Bay": "-04:00",
        "America/Godthab": "-03:00",
        "America/Goose_Bay": "-04:00",
        "America/Grand_Turk": "-05:00",
        "America/Grenada": "-04:00",
        "America/Guadeloupe": "-04:00",
        "America/Guatemala": "-06:00",
        "America/Guayaquil": "-05:00",
        "America/Guyana": "-04:00",
        "America/Halifax": "-04:00",
        "America/Havana": "-05:00",
        "America/Hermosillo": "-07:00",
        "America/Indiana/Indianapolis": "-05:00",
        "America/Indiana/Knox": "-06:00",
        "America/Indiana/Marengo": "-05:00",
        "America/Indiana/Petersburg": "-05:00",
        "America/Indiana/Tell_City": "-06:00",
        "America/Indiana/Vevay": "-05:00",
        "America/Indiana/Vincennes": "-05:00",
        "America/Indiana/Winamac": "-05:00",
        "America/Indianapolis": "-05:00",
        "America/Inuvik": "-07:00",
        "America/Iqaluit": "-05:00",
        "America/Jamaica": "-05:00",
        "America/Jujuy": "-03:00",
        "America/Juneau": "-09:00",
        "America/Kentucky/Louisville": "-05:00",
        "America/Kentucky/Monticello": "-05:00",
        "America/Knox_IN": "-06:00",
        "America/Kralendijk": "-04:00",
        "America/La_Paz": "-04:00",
        "America/Lima": "-05:00",
        "America/Los_Angeles": "-08:00",
        "America/Louisville": "-05:00",
        "America/Lower_Princes": "-04:00",
        "America/Maceio": "-03:00",
        "America/Managua": "-06:00",
        "America/Manaus": "-04:00",
        "America/Marigot": "-04:00",
        "America/Martinique": "-04:00",
        "America/Matamoros": "-06:00",
        "America/Mazatlan": "-07:00",
        "America/Mendoza": "-03:00",
        "America/Menominee": "-06:00",
        "America/Merida": "-06:00",
        "America/Metlakatla": "-09:00",
        "America/Mexico_City": "-06:00",
        "America/Miquelon": "-03:00",
        "America/Moncton": "-04:00",
        "America/Monterrey": "-06:00",
        "America/Montevideo": "-03:00",
        "America/Montreal": "-05:00",
        "America/Montserrat": "-04:00",
        "America/Nassau": "-05:00",
        "America/New_York": "-05:00",
        "America/Nipigon": "-05:00",
        "America/Nome": "-09:00",
        "America/Noronha": "-02:00",
        "America/North_Dakota/Beulah": "-06:00",
        "America/North_Dakota/Center": "-06:00",
        "America/North_Dakota/New_Salem": "-06:00",
        "America/Nuuk": "-03:00",
        "America/Ojinaga": "-07:00",
        "America/Panama": "-05:00",
        "America/Pangnirtung": "-05:00",
        "America/Paramaribo": "-03:00",
        "America/Phoenix": "-07:00",
        "America/Port-au-Prince": "-05:00",
        "America/Port_of_Spain": "-04:00",
        "America/Porto_Acre": "-05:00",
        "America/Porto_Velho": "-04:00",
        "America/Puerto_Rico": "-04:00",
        "America/Punta_Arenas": "-03:00",
        "America/Rainy_River": "-06:00",
        "America/Rankin_Inlet": "-06:00",
        "America/Recife": "-03:00",
        "America/Regina": "-06:00",
        "America/Resolute": "-06:00",
        "America/Rio_Branco": "-05:00",
        "America/Rosario": "-03:00",
        "America/Santa_Isabel": "-08:00",
        "America/Santarem": "-03:00",
        "America/Santiago": "-04:00",
        "America/Santo_Domingo": "-04:00",
        "America/Sao_Paulo": "-03:00",
        "America/Scoresbysund": "-01:00",
        "America/Shiprock": "-07:00",
        "America/Sitka": "-09:00",
        "America/St_Barthelemy": "-04:00",
        "America/St_Johns": "-03:30",
        "America/St_Kitts": "-04:00",
        "America/St_Lucia": "-04:00",
        "America/St_Thomas": "-04:00",
        "America/St_Vincent": "-04:00",
        "America/Swift_Current": "-06:00",
        "America/Tegucigalpa": "-06:00",
        "America/Thule": "-04:00",
        "America/Thunder_Bay": "-05:00",
        "America/Tijuana": "-08:00",
        "America/Toronto": "-05:00",
        "America/Tortola": "-04:00",
        "America/Vancouver": "-08:00",
        "America/Virgin": "-04:00",
        "America/Whitehorse": "-07:00",
        "America/Winnipeg": "-06:00",
        "America/Yakutat": "-09:00",
        "America/Yellowknife": "-07:00",
        "Antarctica/Casey": "+11:00",
        "Antarctica/Davis": "+07:00",
        "Antarctica/DumontDUrville": "+10:00",
        "Antarctica/Macquarie": "+10:00",
        "Antarctica/Mawson": "+05:00",
        "Antarctica/McMurdo": "+12:00",
        "Antarctica/Palmer": "-03:00",
        "Antarctica/Rothera": "-03:00",
        "Antarctica/South_Pole": "+12:00",
        "Antarctica/Syowa": "+03:00",
        "Antarctica/Troll": "+00:00",
        "Antarctica/Vostok": "+06:00",
        "Arctic/Longyearbyen": "+01:00",
        "Asia/Aden": "+03:00",
        "Asia/Almaty": "+06:00",
        "Asia/Amman": "+02:00",
        "Asia/Anadyr": "+12:00",
        "Asia/Aqtau": "+05:00",
        "Asia/Aqtobe": "+05:00",
        "Asia/Ashgabat": "+05:00",
        "Asia/Ashkhabad": "+05:00",
        "Asia/Atyrau": "+05:00",
        "Asia/Baghdad": "+03:00",
        "Asia/Bahrain": "+03:00",
        "Asia/Baku": "+04:00",
        "Asia/Bangkok": "+07:00",
        "Asia/Barnaul": "+07:00",
        "Asia/Beirut": "+02:00",
        "Asia/Bishkek": "+06:00",
        "Asia/Brunei": "+08:00",
        "Asia/Calcutta": "+05:30",
        "Asia/Chita": "+09:00",
        "Asia/Choibalsan": "+08:00",
        "Asia/Chongqing": "+08:00",
        "Asia/Chungking": "+08:00",
        "Asia/Colombo": "+05:30",
        "Asia/Dacca": "+06:00",
        "Asia/Damascus": "+02:00",
        "Asia/Dhaka": "+06:00",
        "Asia/Dili": "+09:00",
        "Asia/Dubai": "+04:00",
        "Asia/Dushanbe": "+05:00",
        "Asia/Famagusta": "+02:00",
        "Asia/Gaza": "+02:00",
        "Asia/Harbin": "+08:00",
        "Asia/Hebron": "+02:00",
        "Asia/Ho_Chi_Minh": "+07:00",
        "Asia/Hong_Kong": "+08:00",
        "Asia/Hovd": "+07:00",
        "Asia/Irkutsk": "+08:00",
        "Asia/Istanbul": "+03:00",
        "Asia/Jakarta": "+07:00",
        "Asia/Jayapura": "+09:00",
        "Asia/Jerusalem": "+02:00",
        "Asia/Kabul": "+04:30",
        "Asia/Kamchatka": "+12:00",
        "Asia/Karachi": "+05:00",
        "Asia/Kashgar": "+06:00",
        "Asia/Kathmandu": "+05:45",
        "Asia/Katmandu": "+05:45",
        "Asia/Khandyga": "+09:00",
        "Asia/Kolkata": "+05:30",
        "Asia/Krasnoyarsk": "+07:00",
        "Asia/Kuala_Lumpur": "+08:00",
        "Asia/Kuching": "+08:00",
        "Asia/Kuwait": "+03:00",
        "Asia/Macao": "+08:00",
        "Asia/Macau": "+08:00",
        "Asia/Magadan": "+11:00",
        "Asia/Makassar": "+08:00",
        "Asia/Manila": "+08:00",
        "Asia/Muscat": "+04:00",
        "Asia/Nicosia": "+02:00",
        "Asia/Novokuznetsk": "+07:00",
        "Asia/Novosibirsk": "+07:00",
        "Asia/Omsk": "+06:00",
        "Asia/Oral": "+05:00",
        "Asia/Phnom_Penh": "+07:00",
        "Asia/Pontianak": "+07:00",
        "Asia/Pyongyang": "+09:00",
        "Asia/Qatar": "+03:00",
        "Asia/Qostanay": "+06:00",
        "Asia/Qyzylorda": "+05:00",
        "Asia/Rangoon": "+06:30",
        "Asia/Riyadh": "+03:00",
        "Asia/Saigon": "+07:00",
        "Asia/Sakhalin": "+11:00",
        "Asia/Samarkand": "+05:00",
        "Asia/Seoul": "+09:00",
        "Asia/Shanghai": "+08:00",
        "Asia/Singapore": "+08:00",
        "Asia/Srednekolymsk": "+11:00",
        "Asia/Taipei": "+08:00",
        "Asia/Tashkent": "+05:00",
        "Asia/Tbilisi": "+04:00",
        "Asia/Tehran": "+03:30",
        "Asia/Tel_Aviv": "+02:00",
        "Asia/Thimbu": "+06:00",
        "Asia/Thimphu": "+06:00",
        "Asia/Tokyo": "+09:00",
        "Asia/Tomsk": "+07:00",
        "Asia/Ujung_Pandang": "+08:00",
        "Asia/Ulaanbaatar": "+08:00",
        "Asia/Ulan_Bator": "+08:00",
        "Asia/Urumqi": "+06:00",
        "Asia/Ust-Nera": "+10:00",
        "Asia/Vientiane": "+07:00",
        "Asia/Vladivostok": "+10:00",
        "Asia/Yakutsk": "+09:00",
        "Asia/Yangon": "+06:30",
        "Asia/Yekaterinburg": "+05:00",
        "Asia/Yerevan": "+04:00",
        "Atlantic/Azores": "-01:00",
        "Atlantic/Bermuda": "-04:00",
        "Atlantic/Canary": "+00:00",
        "Atlantic/Cape_Verde": "-01:00",
        "Atlantic/Faeroe": "+00:00",
        "Atlantic/Faroe": "+00:00",
        "Atlantic/Jan_Mayen": "+01:00",
        "Atlantic/Madeira": "+00:00",
        "Atlantic/Reykjavik": "+00:00",
        "Atlantic/South_Georgia": "-02:00",
        "Atlantic/St_Helena": "+00:00",
        "Atlantic/Stanley": "-03:00",
        "Australia/ACT": "+10:00",
        "Australia/Adelaide": "+09:30",
        "Australia/Brisbane": "+10:00",
        "Australia/Broken_Hill": "+09:30",
        "Australia/Canberra": "+10:00",
        "Australia/Currie": "+10:00",
        "Australia/Darwin": "+09:30",
        "Australia/Eucla": "+08:45",
        "Australia/Hobart": "+10:00",
        "Australia/LHI": "+10:30",
        "Australia/Lindeman": "+10:00",
        "Australia/Lord_Howe": "+10:30",
        "Australia/Melbourne": "+10:00",
        "Australia/North": "+09:30",
        "Australia/NSW": "+10:00",
        "Australia/Perth": "+08:00",
        "Australia/Queensland": "+10:00",
        "Australia/South": "+09:30",
        "Australia/Sydney": "+10:00",
        "Australia/Tasmania": "+10:00",
        "Australia/Victoria": "+10:00",
        "Australia/West": "+08:00",
        "Australia/Yancowinna": "+09:30",
        "Brazil/Acre": "-05:00",
        "Brazil/DeNoronha": "-02:00",
        "Brazil/East": "-03:00",
        "Brazil/West": "-04:00",
        "Canada/Atlantic": "-04:00",
        "Canada/Central": "-06:00",
        "Canada/Eastern": "-05:00",
        "Canada/Mountain": "-07:00",
        "Canada/Newfoundland": "-03:30",
        "Canada/Pacific": "-08:00",
        "Canada/Saskatchewan": "-06:00",
        "Canada/Yukon": "-07:00",
        CET: "+01:00",
        "Chile/Continental": "-04:00",
        "Chile/EasterIsland": "-06:00",
        CST6CDT: "-06:00",
        Cuba: "-05:00",
        EET: "+02:00",
        Egypt: "+02:00",
        Eire: "+01:00",
        EST: "-05:00",
        EST5EDT: "-05:00",
        "Etc/GMT": "+00:00",
        "Etc/GMT+0": "+00:00",
        "Etc/GMT+1": "-01:00",
        "Etc/GMT+10": "-10:00",
        "Etc/GMT+11": "-11:00",
        "Etc/GMT+12": "-12:00",
        "Etc/GMT+2": "-02:00",
        "Etc/GMT+3": "-03:00",
        "Etc/GMT+4": "-04:00",
        "Etc/GMT+5": "-05:00",
        "Etc/GMT+6": "-06:00",
        "Etc/GMT+7": "-07:00",
        "Etc/GMT+8": "-08:00",
        "Etc/GMT+9": "-09:00",
        "Etc/GMT-0": "+00:00",
        "Etc/GMT-1": "+01:00",
        "Etc/GMT-10": "+10:00",
        "Etc/GMT-11": "+11:00",
        "Etc/GMT-12": "+12:00",
        "Etc/GMT-13": "+13:00",
        "Etc/GMT-14": "+14:00",
        "Etc/GMT-2": "+02:00",
        "Etc/GMT-3": "+03:00",
        "Etc/GMT-4": "+04:00",
        "Etc/GMT-5": "+05:00",
        "Etc/GMT-6": "+06:00",
        "Etc/GMT-7": "+07:00",
        "Etc/GMT-8": "+08:00",
        "Etc/GMT-9": "+09:00",
        "Etc/GMT0": "+00:00",
        "Etc/Greenwich": "+00:00",
        "Etc/UCT": "+00:00",
        "Etc/Universal": "+00:00",
        "Etc/UTC": "+00:00",
        "Etc/Zulu": "+00:00",
        "Europe/Amsterdam": "+01:00",
        "Europe/Andorra": "+01:00",
        "Europe/Astrakhan": "+04:00",
        "Europe/Athens": "+02:00",
        "Europe/Belfast": "+00:00",
        "Europe/Belgrade": "+01:00",
        "Europe/Berlin": "+01:00",
        "Europe/Bratislava": "+01:00",
        "Europe/Brussels": "+01:00",
        "Europe/Bucharest": "+02:00",
        "Europe/Budapest": "+01:00",
        "Europe/Busingen": "+01:00",
        "Europe/Chisinau": "+02:00",
        "Europe/Copenhagen": "+01:00",
        "Europe/Dublin": "+01:00",
        "Europe/Gibraltar": "+01:00",
        "Europe/Guernsey": "+00:00",
        "Europe/Helsinki": "+02:00",
        "Europe/Isle_of_Man": "+00:00",
        "Europe/Istanbul": "+03:00",
        "Europe/Jersey": "+00:00",
        "Europe/Kaliningrad": "+02:00",
        "Europe/Kiev": "+02:00",
        "Europe/Kirov": "+03:00",
        "Europe/Lisbon": "+00:00",
        "Europe/Ljubljana": "+01:00",
        "Europe/London": "+00:00",
        "Europe/Luxembourg": "+01:00",
        "Europe/Madrid": "+01:00",
        "Europe/Malta": "+01:00",
        "Europe/Mariehamn": "+02:00",
        "Europe/Minsk": "+03:00",
        "Europe/Monaco": "+01:00",
        "Europe/Moscow": "+03:00",
        "Europe/Nicosia": "+02:00",
        "Europe/Oslo": "+01:00",
        "Europe/Paris": "+01:00",
        "Europe/Podgorica": "+01:00",
        "Europe/Prague": "+01:00",
        "Europe/Riga": "+02:00",
        "Europe/Rome": "+01:00",
        "Europe/Samara": "+04:00",
        "Europe/San_Marino": "+01:00",
        "Europe/Sarajevo": "+01:00",
        "Europe/Saratov": "+04:00",
        "Europe/Simferopol": "+03:00",
        "Europe/Skopje": "+01:00",
        "Europe/Sofia": "+02:00",
        "Europe/Stockholm": "+01:00",
        "Europe/Tallinn": "+02:00",
        "Europe/Tirane": "+01:00",
        "Europe/Tiraspol": "+02:00",
        "Europe/Ulyanovsk": "+04:00",
        "Europe/Uzhgorod": "+02:00",
        "Europe/Vaduz": "+01:00",
        "Europe/Vatican": "+01:00",
        "Europe/Vienna": "+01:00",
        "Europe/Vilnius": "+02:00",
        "Europe/Volgograd": "+03:00",
        "Europe/Warsaw": "+01:00",
        "Europe/Zagreb": "+01:00",
        "Europe/Zaporozhye": "+02:00",
        "Europe/Zurich": "+01:00",
        Factory: "+00:00",
        GB: "+00:00",
        "GB-Eire": "+00:00",
        GMT: "+00:00",
        "GMT+0": "+00:00",
        "GMT-0": "+00:00",
        GMT0: "+00:00",
        Greenwich: "+00:00",
        Hongkong: "+08:00",
        HST: "-10:00",
        Iceland: "+00:00",
        "Indian/Antananarivo": "+03:00",
        "Indian/Chagos": "+06:00",
        "Indian/Christmas": "+07:00",
        "Indian/Cocos": "+06:30",
        "Indian/Comoro": "+03:00",
        "Indian/Kerguelen": "+05:00",
        "Indian/Mahe": "+04:00",
        "Indian/Maldives": "+05:00",
        "Indian/Mauritius": "+04:00",
        "Indian/Mayotte": "+03:00",
        "Indian/Reunion": "+04:00",
        Iran: "+03:30",
        Israel: "+02:00",
        Jamaica: "-05:00",
        Japan: "+09:00",
        Kwajalein: "+12:00",
        Libya: "+02:00",
        MET: "+01:00",
        "Mexico/BajaNorte": "-08:00",
        "Mexico/BajaSur": "-07:00",
        "Mexico/General": "-06:00",
        MST: "-07:00",
        MST7MDT: "-07:00",
        Navajo: "-07:00",
        NZ: "+12:00",
        "NZ-CHAT": "+12:45",
        "Pacific/Apia": "+13:00",
        "Pacific/Auckland": "+12:00",
        "Pacific/Bougainville": "+11:00",
        "Pacific/Chatham": "+12:45",
        "Pacific/Chuuk": "+10:00",
        "Pacific/Easter": "-06:00",
        "Pacific/Efate": "+11:00",
        "Pacific/Enderbury": "+13:00",
        "Pacific/Fakaofo": "+13:00",
        "Pacific/Fiji": "+12:00",
        "Pacific/Funafuti": "+12:00",
        "Pacific/Galapagos": "-06:00",
        "Pacific/Gambier": "-09:00",
        "Pacific/Guadalcanal": "+11:00",
        "Pacific/Guam": "+10:00",
        "Pacific/Honolulu": "-10:00",
        "Pacific/Johnston": "-10:00",
        "Pacific/Kiritimati": "+14:00",
        "Pacific/Kosrae": "+11:00",
        "Pacific/Kwajalein": "+12:00",
        "Pacific/Majuro": "+12:00",
        "Pacific/Marquesas": "-09:30",
        "Pacific/Midway": "-11:00",
        "Pacific/Nauru": "+12:00",
        "Pacific/Niue": "-11:00",
        "Pacific/Norfolk": "+11:00",
        "Pacific/Noumea": "+11:00",
        "Pacific/Pago_Pago": "-11:00",
        "Pacific/Palau": "+09:00",
        "Pacific/Pitcairn": "-08:00",
        "Pacific/Pohnpei": "+11:00",
        "Pacific/Ponape": "+11:00",
        "Pacific/Port_Moresby": "+10:00",
        "Pacific/Rarotonga": "-10:00",
        "Pacific/Saipan": "+10:00",
        "Pacific/Samoa": "-11:00",
        "Pacific/Tahiti": "-10:00",
        "Pacific/Tarawa": "+12:00",
        "Pacific/Tongatapu": "+13:00",
        "Pacific/Truk": "+10:00",
        "Pacific/Wake": "+12:00",
        "Pacific/Wallis": "+12:00",
        "Pacific/Yap": "+10:00",
        Poland: "+01:00",
        Portugal: "+00:00",
        PRC: "+08:00",
        PST8PDT: "-08:00",
        ROC: "+08:00",
        ROK: "+09:00",
        Singapore: "+08:00",
        Turkey: "+03:00",
        UCT: "+00:00",
        Universal: "+00:00",
        "US/Alaska": "-09:00",
        "US/Aleutian": "-10:00",
        "US/Arizona": "-07:00",
        "US/Central": "-06:00",
        "US/East-Indiana": "-05:00",
        "US/Eastern": "-05:00",
        "US/Hawaii": "-10:00",
        "US/Indiana-Starke": "-06:00",
        "US/Michigan": "-05:00",
        "US/Mountain": "-07:00",
        "US/Pacific": "-08:00",
        "US/Samoa": "-11:00",
        UTC: "+00:00",
        "W-SU": "+03:00",
        WET: "+00:00",
        Zulu: "+00:00"
    }
};
!function () {
    function a(a) {
        var i = document.createElement("style");
        return i.type = "text/css", i.styleSheet ? i.styleSheet.cssText = a : i.appendChild(document.createTextNode(a)), i
    }

    function i(a, i) {
        for (var e in i) try {
            i[e].constructor == Object ? a[e] = _.extend(a[e], i[e]) : a[e] = i[e]
        } catch (t) {
            a[e] = i[e]
        }
        return a
    }

    function e(a, i) {
        var e = a + (i ? " UTC" + (atcSetup.offsets[i] || "") : "");
        return new Date(e)
    }

    function t(a) {
        var i = a, e = i.getFullYear(), t = `${i.getMonth() + 1}`.padStart(2, "0"),
            r = `${i.getDate()}`.padStart(2, "0"), o = `${i.getHours()}`.padStart(2, "0"),
            n = `${i.getMinutes()}`.padStart(2, "0"), c = `${i.getSeconds()}`.padStart(2, "0");
        return i = e + "-" + t + "-" + r + "T" + o + ":" + n + ":" + c
    }

    function r(a) {
        return a.replace(/-|:|\.\d\d\d/g, "")
    }

    function o(a, i) {
        if (a.Dstart = a.start ? e(a.start, a.timezone) : "", a.Dend = a.end ? e(a.end, a.timezone) : "", a.Dstart && a.Dend && i.dateType) switch (i.dateType) {
            case 1:
                a.Dstart = r(t(a.Dstart)), a.Dend = r(t(a.Dend));
                break;
            case 2:
                a.Dstart = t(a.Dstart), a.Dend = t(a.Dend)
        }
        i.href && function (a, i) {
            Object.keys(i).forEach((function (e) {
                a.includes("{" + e + "}") && (a = a.replace("{" + e + "}", encodeURI(i[e])))
            })), window.open(a)
        }(i.href, a), i.ics && function (a) {
            var i = ["BEGIN:VCALENDAR", "PRODID:", "VERSION:2.0", "BEGIN:VTIMEZONE", "TZID:" + a.timezone, "BEGIN:STANDARD", "DTSTART:", "RRULE:FREQ=YEARLY;BYDAY=1SU;BYMONTH=11", "TZOFFSETFROM:", "TZOFFSETTO:", "TZNAME:PST", "END:STANDARD", "BEGIN:DAYLIGHT", "DTSTART:", "RRULE:FREQ=YEARLY;BYDAY=2SU;BYMONTH=3", "TZOFFSETFROM:", "TZOFFSETTO:", "TZNAME:PDT", "END:DAYLIGHT", "END:VTIMEZONE", "BEGIN:VEVENT", "DTSTAMP:", "STATUS:CONFIRMED", "UID:", "SEQUENCE:0", "DTSTART:" + a.Dstart, "DTEND:" + a.Dend, "SUMMARY:" + a.title, "DESCRIPTION:" + a.description, "X-ALT-DESC;FMTTYPE=text/html:" + a.description, "LOCATION:" + a.location, "TRANSP:OPAQUE", "END:VEVENT", "END:VCALENDAR"];
            i = i.join("\n"), window.open("data:text/calendar;charset=utf-8," + escape(i), "_blank")
        }(a)
    }

    function n(a, i) {
        var e, t, r = i.getBoundingClientRect();
        a.classList.remove("atc-dropdown-bottom"), a.classList.remove("atc-dropdown-top"), r.top + r.height + a.clientHeight + 16 < window.innerHeight ? (e = r.top + r.height + 16, a.classList.add("atc-dropdown-top")) : (e = r.top - a.clientHeight - 16, a.classList.add("atc-dropdown-bottom")), t = r.left + r.width / 2 - a.clientWidth / 2, a.style.top = e + "px", a.style.left = t + "px"
    }

    this.atc = function (a, e) {
        return function (a) {
            let i = !1;
            try {
                fetch(new Request("https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js")).catch((a => i = !0))
            } catch (a) {
                i = !0
            } finally {
                a(i)
            }
        }((function (t) {
            if (!a) return console.error("Invalid element"), !1;
            if (a.classList.contains("atc-loaded")) return !1;
            if (e = i({
                list: ["apple", "google", "yahoo", "outlook"],
                labels: !0,
                theme: "white"
            }, e || {}), ("string" == typeof (e = i(e, function (a) {
                for (var i = a.attributes, e = i.length, t = {}; e--;) if (attr = i[e], attr.value && attr.name.includes("data-atc-")) {
                    var r = attr.name.replace("data-atc-", ""), o = attr.value;
                    ["styled", "labels"].includes(r) && (o = JSON.parse(o.toLowerCase())), t[r] = o
                }
                return t
            }(a))).list || e.list instanceof String) && (e.list = e.list.split(",")), !Array.isArray(e.list)) return console.error("Invalid list"), !1;
            if (e.list.length && e.list.forEach((function (a, i) {
                atcSetup.lib[a] || (e.list = e.list.filter((i => i !== a)))
            })), e.list.includes("apple") && t && (e.list = e.list.filter((a => "apple" !== a))), !e.list.length) return console.error("Empty list"), !1;
            if (!e.start) return console.error("Invalid date"), !1;
            !e.end && e.start && (e.end = e.start);
            atc.prototype;
            a.addEventListener("click", (function () {
                e.list.length > 1 ? function (a, i) {
                    atcSetup.iframe.style.display = "block", a.classList.add("atc-button-active");
                    var e = document.createElement("ul");
                    e.className = "atc-dropdown", i.theme && ["dark", "white"].includes(i.theme) && e.classList.add("atc-" + i.theme), e.classList.add("atc-" + (i.labels ? "block" : "inline")), i.list.forEach((function (a, t) {
                        var r = atcSetup.lib[a], n = document.createElement("li");
                        n.className = "atc-dropdown-item";
                        var c = r.icon;
                        i.labels && (c += "<span>" + r.label + "</span>"), n.innerHTML = c, e.appendChild(n), n.addEventListener("click", (function () {
                            o(i, r)
                        }))
                    })), atcSetup.iframe.contentWindow.document.body.appendChild(e), n(e, a), setTimeout((function () {
                        e.classList.add("atc-dropdown-shown");
                        var i = function (i) {
                            n(e, a)
                        }, t = function (r) {
                            (r = r || window.event).target == e || e.contains(r.target) || (e.classList.remove("atc-dropdown-shown"), a.classList.remove("atc-button-active"), setTimeout((function () {
                                e.remove(), atcSetup.iframe.style.display = "none"
                            }), 600), atcSetup.iframe.contentWindow.document.removeEventListener("click", t), window.removeEventListener("resize", i), window.removeEventListener("scroll", i))
                        };
                        atcSetup.iframe.contentWindow.document.addEventListener("click", t), window.addEventListener("resize", i), window.addEventListener("scroll", i)
                    }), 150)
                }(a, e) : o(e, atcSetup.lib[String(e.list)])
            })), a.classList.contains("atc-button") || a.classList.add("atc-button"), e.theme && ["dark", "white"].includes(e.theme) && a.classList.add("atc-" + e.theme), e.styled && a.classList.add("atc-styled"), a.classList.add("atc-loaded")
        })), a
    }, atcSetup.seek = function () {
        document.querySelectorAll(".atc-button:not(.atc-loaded)").forEach((function (a, i) {
            new atc(a)
        }))
    }, document.addEventListener("DOMContentLoaded", (function () {
        atcSetup.iframe = function (a, i) {
            (i = i || {}).attributes, i.style;
            var e = document.createElement(a);
            return i && Object.keys(i).forEach((function (a) {
                var t = i[a];
                switch (a) {
                    case"html":
                        e.innerHTML = t;
                        break;
                    case"style":
                        Object.keys(t).forEach((function (a) {
                            e.style[a] = t[a]
                        }));
                        break;
                    default:
                        e.setAttribute(a, t)
                }
            })), e
        }("iframe", {
            class: "il__frame",
            style: {
                width: "100%",
                height: "100%",
                border: 0,
                position: "fixed",
                overflow: "hidden",
                top: 0,
                left: 0,
                display: "none",
                zIndex: 2147483647
            }
        }), atcSetup.iframe.onload = function () {
            this.contentWindow.document.getElementsByTagName("head")[0].appendChild(a('body,html{width:100;height:100%;overflow:hidden}.atc-dropdown{position:absolute;border-radius:0.35rem;box-shadow:0 0 1.5rem rgba(0,0,0,0.1);list-style:none;font-family:"Helvetica Neue",sans-serif;margin:0 1rem;transition:all 0.6s cubic-bezier(0.165,0.84,0.44,1);opacity:0;pointer-events:none;visibility:hidden}.atc-dropdown.atc-white{background-color:white;color:#222}.atc-dropdown.atc-white:before{background-color:white}.atc-dropdown.atc-white .atc-dropdown-item svg{background-color:white}.atc-dropdown.atc-white .atc-dropdown-item:not(:last-of-type),.atc-dropdown.atc-white .atc-dropdown-item svg{border-color:rgba(0,0,0,0.1)!important}.atc-dropdown.atc-white.atc-inline .atc-dropdown-item:hover svg{border-color:rgba(0,0,0,0.25)!important}.atc-dropdown.atc-white.atc-block .atc-dropdown-item:hover{background-color:rgba(0,0,0,0.035)}.atc-dropdown.atc-dark{background-color:#333;color:#F4F4F4}.atc-dropdown.atc-dark:before{background-color:#333}.atc-dropdown.atc-dark .atc-dropdown-item{color:white}.atc-dropdown.atc-dark .atc-dropdown-item svg{background-color:rgba(0,0,0,0.2)}.atc-dropdown.atc-dark .atc-dropdown-item svg *{fill:#CCC}.atc-dropdown.atc-dark.atc-inline .atc-dropdown-item:hover svg{background-color:rgba(0,0,0,0.4)!important}.atc-dropdown.atc-dark.atc-block .atc-dropdown-item:not(:last-of-type){border-color:rgba(0,0,0,0.1)!important}.atc-dropdown.atc-dark.atc-block .atc-dropdown-item:hover{background-color:rgba(255,255,255,0.035)}.atc-dropdown,.atc-dropdown *{padding:0;margin:0;border:0}.atc-dropdown:before{display:inline-block;position:absolute;content:"";width:1rem;height:1rem;transform:rotate(45deg) translateX(-50%);left:50%;border-radius:0.125rem}.atc-dropdown-top{transform:translateY(-1rem)}.atc-dropdown-top:before{top:0}.atc-dropdown-bottom{transform:translateY(1rem)}.atc-dropdown-bottom:before{bottom:-0.75rem}.atc-dropdown-shown{opacity:1;transform:translateY(0);pointer-events:auto;visibility:visible}.atc-dropdown.atc-inline{padding:0.5rem;display:flex}.atc-dropdown.atc-inline .atc-dropdown-item:not(:last-of-type){margin-right:0.5rem}.atc-dropdown.atc-block .atc-dropdown-item{padding:0.5rem}.atc-dropdown.atc-block .atc-dropdown-item:not(:last-of-type){border-bottom:1px solid transparent}.atc-dropdown-item{cursor:pointer;display:flex;align-items:center;position:relative}.atc-dropdown-item span{padding:0.75rem}.atc-dropdown-item svg{width:1.25rem;height:1.25rem;padding:1rem;border-radius:0.35rem;flex-shrink:0;border:1px solid transparent}'))
        }, document.body.appendChild(atcSetup.iframe), document.getElementsByTagName("head")[0].appendChild(a(".atc-styled{all:unset;-webkit-appearance:none;appearance:none;border:1px solid transparent;font-weight:bold;padding:0.75rem 1rem 0.75rem 3rem;border-radius:0.35rem;font-family:\"Helvetica Neue\",sans-serif;font-size:100%;cursor:pointer;box-shadow:0 0 1rem rgba(0,0,0,0.1);line-height:1;transition:all 0.6s cubic-bezier(0.165,0.84,0.44,1);outline:0;background-position:center left 0.75rem;background-repeat:no-repeat;display:flex;align-items:center;justify-content:center}.atc-styled *{padding:0;margin:0;border:0}.atc-styled.atc-white{background-color:white;color:#222;background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='25' height='25' viewBox='0 0 25 25'%3E%3Cg fill='none' fill-rule='evenodd' stroke='currentColor' stroke-width='1.5'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' d='M12.5 8.5v8M16.5 12.5h-8'/%3E%3Crect width='21' height='21' x='2' y='2' rx='4'/%3E%3C/g%3E%3C/svg%3E\")}.atc-styled.atc-white-active,.atc-styled.atc-white:hover{background-color:#F0F0F0}.atc-styled.atc-dark{background-color:#222;color:white;background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='25' height='25' viewBox='0 0 25 25'%3E%3Cg fill='none' fill-rule='evenodd' stroke='white' stroke-width='1.5'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' d='M12.5 8.5v8M16.5 12.5h-8'/%3E%3Crect width='21' height='21' x='2' y='2' rx='4'/%3E%3C/g%3E%3C/svg%3E\")}.atc-styled.atc-dark-active,.atc-styled.atc-dark:hover{background-color:#444}.atc-styled svg{margin-right:0.75rem}")), atcSetup.seek()
    }))
}();